import { render, staticRenderFns } from "./CrudJudgingCriteriaList.vue?vue&type=template&id=5a66a86c&"
import script from "./CrudJudgingCriteriaList.vue?vue&type=script&lang=js&"
export * from "./CrudJudgingCriteriaList.vue?vue&type=script&lang=js&"
import style0 from "./CrudJudgingCriteriaList.vue?vue&type=style&index=0&id=5a66a86c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports